import adminClient, { gql } from './graphqlAdminClient';

// Helper to execute a GraphQL request with admin client
export async function graphqlAdminRequest(query, variables = {}, token) {
  // Optionally add token to headers if needed in the future
  // For now, assume adminClient is configured for auth
  
  const result = await adminClient.query({
    query: typeof query === 'string' ? gql(query) : query,
    variables,
    fetchPolicy: 'no-cache',
    context: {
      headers: { Authorization: `Bearer ${token}` }, // Uncomment if token needed
    },
  });
  // Apollo returns data/errors in result
  if (result.errors && result.errors.length > 0) {
    throw new Error(result.errors.map(e => e.message).join(', '));
  }
  return result.data;
}

// Helper to execute a GraphQL mutation with admin client
export async function executeAdminMutation(mutation, variables = {}, token) {
  console.log('Executing admin mutation with variables:', variables, mutation, token);
  try {
    const result = await adminClient.mutate({
      mutation: typeof mutation === 'string' ? gql(mutation) : mutation,
      variables,
      context: {
        headers: { Authorization: `Bearer ${token}` },
      },
    });
    if (result.errors && result.errors.length > 0) {
      console.error('GraphQL errors:', result.errors);
      throw new Error(result.errors.map(e => e.message).join(', '));
    }
    return result.data;
  } catch (err) {
    // Apollo errors may be in err.graphQLErrors or err.networkError
    if (err.graphQLErrors && err.graphQLErrors.length > 0) {
      console.error('GraphQL errors:', err.graphQLErrors);
      throw new Error('GraphQL error: ' + err.graphQLErrors.map(e => e.message).join(', '));
    }
    if (err.networkError) {
      console.error('Network error:', err.networkError);
      throw new Error('Network error: ' + err.networkError.message);
    }
    console.error('Unknown error during mutation:', err);
    throw err;
  }
}
